import { lazy } from 'react'

export const EventDateV1 = lazy(() => import('./v1/EventDateV1'))
export const EventDateV2 = lazy(() => import('./v2/EventDateV2'))
